import type { About as AboutType } from './types';
import Section from '@Components/Section/Section';
import NarrativeSection from './NarrativeSection';
import SectionHeader from '@Components/Section/SectionHeader';
import type { ReactElement } from 'react';
import YAML from '@Layouts/YAML';
import Page from '@Components/Page';
import { PartnerLogos } from './PartnerLogos';
import PageTitle from '@/Components/PageTitle';

const AboutContent = (about: AboutType): ReactElement => {
    const content = about;
    return (
        <div className='w-[80%] sm:w-[90%] mx-auto'>
            <PageTitle>{about.sections.main.title}</PageTitle>
            <Page>
                <NarrativeSection
                    sectionWrapperClassName='m-0'
                    sectionHeaderClassName='text-4xl'
                    {...content.sections.main}
                />

                <Section shaded={true}>
                    <SectionHeader>Partners</SectionHeader>
                    <PartnerLogos partners={content.sections.partners} maxBoxesPerRow={6} imageHeight='sm' />
                </Section>

                <NarrativeSection shaded={false} {...content.sections.contact} />
                <NarrativeSection shaded={true} {...content.sections.funding} />
            </Page>
        </div>
    );
}

const About = (): ReactElement => {
    return <>

        <YAML<AboutType>
            yamlFile="/yaml_content/about.yaml"
            Component={AboutContent}
        />
    </>
}

export default About
